// AWS Pricing & FinOps Engine Configuration Data
// Standard AWS us-east-1 reference pricing with regional and commitment multipliers

export const CURRENCIES = {
  USD: { symbol: '$', rate: 1.0, label: 'USD ($)' },
  EUR: { symbol: '€', rate: 0.92, label: 'EUR (€)' },
  GBP: { symbol: '£', rate: 0.78, label: 'GBP (£)' }
};

export const AWS_REGIONS = [
  { id: 'us-east-1', name: 'US East (N. Virginia)', multiplier: 1.00 },
  { id: 'us-west-2', name: 'US West (Oregon)', multiplier: 1.00 },
  { id: 'eu-central-1', name: 'Europe (Frankfurt)', multiplier: 1.10 },
  { id: 'eu-west-1', name: 'Europe (Ireland)', multiplier: 1.07 },
  { id: 'eu-north-1', name: 'Europe (Stockholm)', multiplier: 1.05 }
];

export const EC2_INSTANCES = [
  // Burstable / Graviton
  { id: 't4g.nano', family: 'General Purpose (Graviton)', vcpu: 2, ram: 0.5, hourlyRate: 0.0042, network: 'Up to 5 Gbps' },
  { id: 't4g.micro', family: 'General Purpose (Graviton)', vcpu: 2, ram: 1.0, hourlyRate: 0.0084, network: 'Up to 5 Gbps' },
  { id: 't4g.small', family: 'General Purpose (Graviton)', vcpu: 2, ram: 2.0, hourlyRate: 0.0168, network: 'Up to 5 Gbps' },
  { id: 't4g.medium', family: 'General Purpose (Graviton)', vcpu: 2, ram: 4.0, hourlyRate: 0.0336, network: 'Up to 5 Gbps' },
  { id: 't4g.large', family: 'General Purpose (Graviton)', vcpu: 2, ram: 8.0, hourlyRate: 0.0672, network: 'Up to 5 Gbps' },
  { id: 't4g.xlarge', family: 'General Purpose (Graviton)', vcpu: 4, ram: 16.0, hourlyRate: 0.1344, network: 'Up to 5 Gbps' },
  
  // General Purpose x86
  { id: 't3.small', family: 'General Purpose (x86)', vcpu: 2, ram: 2.0, hourlyRate: 0.0208, network: 'Up to 5 Gbps' },
  { id: 't3.medium', family: 'General Purpose (x86)', vcpu: 2, ram: 4.0, hourlyRate: 0.0416, network: 'Up to 5 Gbps' },
  { id: 't3.large', family: 'General Purpose (x86)', vcpu: 2, ram: 8.0, hourlyRate: 0.0832, network: 'Up to 5 Gbps' },
  { id: 'm6g.large', family: 'General Purpose (Graviton)', vcpu: 2, ram: 8.0, hourlyRate: 0.0770, network: 'Up to 10 Gbps' },
  { id: 'm6g.xlarge', family: 'General Purpose (Graviton)', vcpu: 4, ram: 16.0, hourlyRate: 0.1540, network: 'Up to 10 Gbps' },
  { id: 'm6g.2xlarge', family: 'General Purpose (Graviton)', vcpu: 8, ram: 32.0, hourlyRate: 0.3080, network: 'Up to 12.5 Gbps' },
  { id: 'm5.large', family: 'General Purpose (Intel)', vcpu: 2, ram: 8.0, hourlyRate: 0.0960, network: 'Up to 10 Gbps' },
  { id: 'm5.xlarge', family: 'General Purpose (Intel)', vcpu: 4, ram: 16.0, hourlyRate: 0.1920, network: 'Up to 10 Gbps' },

  // Compute Optimized
  { id: 'c6g.large', family: 'Compute Optimized (Graviton)', vcpu: 2, ram: 4.0, hourlyRate: 0.0680, network: 'Up to 10 Gbps' },
  { id: 'c6g.xlarge', family: 'Compute Optimized (Graviton)', vcpu: 4, ram: 8.0, hourlyRate: 0.1360, network: 'Up to 10 Gbps' },
  { id: 'c6g.2xlarge', family: 'Compute Optimized (Graviton)', vcpu: 8, ram: 16.0, hourlyRate: 0.2720, network: 'Up to 12.5 Gbps' },
  { id: 'c6i.large', family: 'Compute Optimized (Intel)', vcpu: 2, ram: 4.0, hourlyRate: 0.0850, network: 'Up to 12.5 Gbps' },
  { id: 'c6i.xlarge', family: 'Compute Optimized (Intel)', vcpu: 4, ram: 8.0, hourlyRate: 0.1700, network: 'Up to 12.5 Gbps' },
  { id: 'c6i.2xlarge', family: 'Compute Optimized (Intel)', vcpu: 8, ram: 16.0, hourlyRate: 0.3400, network: '12.5 Gbps' },

  // Memory Optimized
  { id: 'r6g.large', family: 'Memory Optimized (Graviton)', vcpu: 2, ram: 16.0, hourlyRate: 0.1008, network: 'Up to 10 Gbps' },
  { id: 'r6g.xlarge', family: 'Memory Optimized (Graviton)', vcpu: 4, ram: 32.0, hourlyRate: 0.2016, network: 'Up to 10 Gbps' },
  { id: 'r6g.2xlarge', family: 'Memory Optimized (Graviton)', vcpu: 8, ram: 64.0, hourlyRate: 0.4032, network: 'Up to 12.5 Gbps' },
  { id: 'r5.large', family: 'Memory Optimized (Intel)', vcpu: 2, ram: 16.0, hourlyRate: 0.1260, network: 'Up to 10 Gbps' },
  { id: 'r5.xlarge', family: 'Memory Optimized (Intel)', vcpu: 4, ram: 32.0, hourlyRate: 0.2520, network: 'Up to 10 Gbps' }
];

export const RDS_ENGINES = [
  { id: 'postgres', name: 'PostgreSQL (Multi-AZ Ready)', baseMultiplier: 1.0 },
  { id: 'mysql', name: 'MySQL Community Edition', baseMultiplier: 0.95 },
  { id: 'aurora-serverless', name: 'Amazon Aurora Serverless v2', baseMultiplier: 1.40, isServerless: true }
];

export const RDS_INSTANCE_CLASSES = [
  { id: 'db.t4g.micro', vcpu: 2, ram: 1, hourlyRate: 0.016 },
  { id: 'db.t4g.small', vcpu: 2, ram: 2, hourlyRate: 0.032 },
  { id: 'db.t4g.medium', vcpu: 2, ram: 4, hourlyRate: 0.068 },
  { id: 'db.m6g.large', vcpu: 2, ram: 8, hourlyRate: 0.155 },
  { id: 'db.m6g.xlarge', vcpu: 4, ram: 16, hourlyRate: 0.310 },
  { id: 'db.r6g.large', vcpu: 2, ram: 16, hourlyRate: 0.209 },
  { id: 'db.r6g.xlarge', vcpu: 4, ram: 32, hourlyRate: 0.418 }
];

export const STORAGE_RATES = {
  ebs_gp3_gb_month: 0.08, // Baseline includes 3,000 IOPS & 125 MB/s throughput
  ebs_io2_gb_month: 0.125,
  ebs_snapshot_gb_month: 0.05,
  s3_standard_gb_month: 0.023,
  s3_ia_gb_month: 0.0125,
  s3_glacier_gb_month: 0.0036,
  s3_put_per_1000: 0.005,
  s3_get_per_1000: 0.0004
};

export const NETWORKING_RATES = {
  nat_gateway_hourly: 0.045, // ~$32.40 / month / NAT GW
  nat_data_processed_gb: 0.045, // $0.045 per GB processed through NAT
  alb_hourly: 0.0225, // ~$16.20 / month / ALB
  alb_lcu_hourly: 0.008, // ~$5.76 / month per LCU
  internet_egress_free_gb: 100,
  internet_egress_rate_gb: 0.09,
  cross_az_egress_gb: 0.01 // $0.01/GB each direction = $0.02/GB round-trip
};

export const FINOPS_SAVINGS_RATIOS = {
  on_demand: { discount: 0, label: 'On-Demand (0% commitment)', commitment: '0 Months' },
  savings_plan_1yr: { discount: 0.36, label: 'Compute Savings Plan 1-Yr No-Upfront (36% off)', commitment: '12 Months' },
  savings_plan_3yr: { discount: 0.62, label: 'EC2 Instance Savings Plan 3-Yr Partial-Upfront (62% off)', commitment: '36 Months' }
};

// Architecture Presets for rapid 1-click modeling
export const ARCHITECTURE_PRESETS = [
  {
    id: 'lean_mvp',
    name: 'Lean Startup MVP',
    badge: 'Bootstrapped',
    description: 'Cost-minimized single-AZ architecture with burstable Graviton instances, managed PostgreSQL, and S3 assets.',
    config: {
      region: 'us-east-1',
      ec2: {
        instanceId: 't4g.small',
        quantity: 2,
        operatingHours: 730,
        ebsSizeGb: 30,
        ebsType: 'gp3',
        ebsSnapshotsGb: 20
      },
      s3: {
        standardGb: 150,
        iaGb: 50,
        glacierGb: 0,
        monthlyPutsK: 100,
        monthlyGetsK: 500
      },
      rds: {
        engine: 'postgres',
        instanceClass: 'db.t4g.micro',
        multiAz: false,
        storageGb: 40,
        backupRetentionDays: 7
      },
      networking: {
        natGatewayCount: 1,
        natDataGb: 80,
        albCount: 1,
        albLcus: 1,
        internetEgressGb: 250,
        multiAzEgressGb: 50
      },
      commitmentPlan: 'on_demand',
      burstMultiplier: 1.0
    }
  },
  {
    id: 'ha_enterprise_3tier',
    name: 'High-Availability 3-Tier Enterprise',
    badge: 'Enterprise Production',
    description: 'Resilient Multi-AZ architecture across 3 Availability Zones with Dual NAT Gateways, ALB, and Multi-AZ RDS PostgreSQL.',
    config: {
      region: 'us-east-1',
      ec2: {
        instanceId: 'm6g.xlarge',
        quantity: 6,
        operatingHours: 730,
        ebsSizeGb: 100,
        ebsType: 'gp3',
        ebsSnapshotsGb: 100
      },
      s3: {
        standardGb: 1500,
        iaGb: 3000,
        glacierGb: 5000,
        monthlyPutsK: 2500,
        monthlyGetsK: 15000
      },
      rds: {
        engine: 'postgres',
        instanceClass: 'db.m6g.large',
        multiAz: true,
        storageGb: 500,
        backupRetentionDays: 30
      },
      networking: {
        natGatewayCount: 2,
        natDataGb: 600,
        albCount: 2,
        albLcus: 4,
        internetEgressGb: 2000,
        multiAzEgressGb: 800
      },
      commitmentPlan: 'savings_plan_1yr',
      burstMultiplier: 1.0
    }
  },
  {
    id: 'data_analytics_heavy',
    name: 'Data Analytics & Memory Cluster',
    badge: 'Big Data & ML',
    description: 'High-throughput cluster with memory-optimized R6g instances, Aurora Serverless v2, large S3 data lake, and high egress.',
    config: {
      region: 'us-east-1',
      ec2: {
        instanceId: 'r6g.xlarge',
        quantity: 4,
        operatingHours: 730,
        ebsSizeGb: 250,
        ebsType: 'gp3',
        ebsSnapshotsGb: 200
      },
      s3: {
        standardGb: 10000,
        iaGb: 20000,
        glacierGb: 30000,
        monthlyPutsK: 10000,
        monthlyGetsK: 45000
      },
      rds: {
        engine: 'aurora-serverless',
        instanceClass: 'db.r6g.large',
        multiAz: true,
        storageGb: 1200,
        backupRetentionDays: 35
      },
      networking: {
        natGatewayCount: 2,
        natDataGb: 2500,
        albCount: 1,
        albLcus: 5,
        internetEgressGb: 5000,
        multiAzEgressGb: 3000
      },
      commitmentPlan: 'savings_plan_3yr',
      burstMultiplier: 1.0
    }
  },
  {
    id: 'cost_optimized_finops',
    name: 'Cost-Optimized FinOps Profile',
    badge: 'FinOps Tuned',
    description: 'Graviton-first architecture utilizing 3-Year Savings Plans, single shared NAT with VPC endpoints, and gp3 storage to slash TCO.',
    config: {
      region: 'us-east-1',
      ec2: {
        instanceId: 't4g.medium',
        quantity: 3,
        operatingHours: 730,
        ebsSizeGb: 50,
        ebsType: 'gp3',
        ebsSnapshotsGb: 30
      },
      s3: {
        standardGb: 500,
        iaGb: 1200,
        glacierGb: 2000,
        monthlyPutsK: 400,
        monthlyGetsK: 2000
      },
      rds: {
        engine: 'postgres',
        instanceClass: 'db.t4g.small',
        multiAz: false,
        storageGb: 100,
        backupRetentionDays: 14
      },
      networking: {
        natGatewayCount: 1,
        natDataGb: 150,
        albCount: 1,
        albLcus: 1.5,
        internetEgressGb: 600,
        multiAzEgressGb: 100
      },
      commitmentPlan: 'savings_plan_3yr',
      burstMultiplier: 1.0
    }
  }
];

// Sizing & Cost Aggregator
export const calculateCloudCosts = (config) => {
  const {
    region = 'us-east-1',
    ec2 = {},
    s3 = {},
    rds = {},
    networking = {},
    commitmentPlan = 'on_demand',
    burstMultiplier = 1.0
  } = config;

  // Regional Multiplier
  const regionObj = AWS_REGIONS.find(r => r.id === region) || AWS_REGIONS[0];
  const rMult = regionObj.multiplier;

  // 1. EC2 Compute Calculations
  const instanceObj = EC2_INSTANCES.find(i => i.id === ec2.instanceId) || EC2_INSTANCES[3];
  const rawHourly = instanceObj.hourlyRate * rMult;
  const operatingHours = Math.min(730, Math.max(1, Number(ec2.operatingHours) || 730));
  const baseEc2Qty = Math.max(1, Number(ec2.quantity) || 1);
  const effectiveEc2Qty = Math.round(baseEc2Qty * Math.max(1, burstMultiplier));
  
  const ec2OnDemandMonthly = effectiveEc2Qty * rawHourly * operatingHours;
  
  const planObj = FINOPS_SAVINGS_RATIOS[commitmentPlan] || FINOPS_SAVINGS_RATIOS.on_demand;
  const computeDiscount = planObj.discount;
  const ec2ComputeMonthly = ec2OnDemandMonthly * (1 - computeDiscount);
  const ec2SavingsMonthly = ec2OnDemandMonthly * computeDiscount;

  // EBS Storage
  const ebsRate = ec2.ebsType === 'io2' ? STORAGE_RATES.ebs_io2_gb_month : STORAGE_RATES.ebs_gp3_gb_month;
  const ebsGb = Math.max(10, Number(ec2.ebsSizeGb) || 30);
  const ebsSnapshotsGb = Math.max(0, Number(ec2.ebsSnapshotsGb) || 0);
  const ebsMonthly = effectiveEc2Qty * (ebsGb * ebsRate * rMult) + (ebsSnapshotsGb * STORAGE_RATES.ebs_snapshot_gb_month * rMult);

  const totalEc2Monthly = ec2ComputeMonthly + ebsMonthly;

  // 2. S3 Object Storage Calculations
  const s3StdGb = Math.max(0, Number(s3.standardGb) || 0);
  const s3IaGb = Math.max(0, Number(s3.iaGb) || 0);
  const s3GlacierGb = Math.max(0, Number(s3.glacierGb) || 0);
  const s3PutsK = Math.max(0, Number(s3.monthlyPutsK) || 0) * Math.max(1, burstMultiplier);
  const s3GetsK = Math.max(0, Number(s3.monthlyGetsK) || 0) * Math.max(1, burstMultiplier);

  const s3StorageCost = (
    (s3StdGb * STORAGE_RATES.s3_standard_gb_month) +
    (s3IaGb * STORAGE_RATES.s3_ia_gb_month) +
    (s3GlacierGb * STORAGE_RATES.s3_glacier_gb_month)
  ) * rMult;

  const s3RequestsCost = (
    (s3PutsK * STORAGE_RATES.s3_put_per_1000) +
    (s3GetsK * STORAGE_RATES.s3_get_per_1000)
  ) * rMult;

  const totalS3Monthly = s3StorageCost + s3RequestsCost;

  // 3. Amazon RDS Calculations
  const rdsClassObj = RDS_INSTANCE_CLASSES.find(c => c.id === rds.instanceClass) || RDS_INSTANCE_CLASSES[1];
  const rdsEngineObj = RDS_ENGINES.find(e => e.id === rds.engine) || RDS_ENGINES[0];
  
  const isMultiAz = Boolean(rds.multiAz);
  const rdsAzMultiplier = isMultiAz ? 2.0 : 1.0;
  const rdsEngineMultiplier = rdsEngineObj.baseMultiplier;

  const rdsBaseHourly = rdsClassObj.hourlyRate * rMult * rdsEngineMultiplier;
  const rdsComputeMonthly = rdsBaseHourly * 730 * rdsAzMultiplier;

  const rdsStorageGb = Math.max(20, Number(rds.storageGb) || 20);
  const rdsStorageMonthly = (rdsStorageGb * 0.115 * rdsAzMultiplier * rMult);
  
  const backupDays = Math.max(1, Number(rds.backupRetentionDays) || 7);
  const extraBackupGb = Math.max(0, (rdsStorageGb * (backupDays / 30)) - rdsStorageGb);
  const rdsBackupMonthly = extraBackupGb * STORAGE_RATES.ebs_snapshot_gb_month * rMult;

  const totalRdsMonthly = rdsComputeMonthly + rdsStorageMonthly + rdsBackupMonthly;

  // 4. Networking & VPC Calculations
  const natCount = Math.max(0, Number(networking.natGatewayCount) || 0);
  const baseNatDataGb = Math.max(0, Number(networking.natDataGb) || 0);
  const effectiveNatDataGb = baseNatDataGb * Math.max(1, burstMultiplier);
  const natHourlyCost = natCount * (NETWORKING_RATES.nat_gateway_hourly * 730 * rMult);
  const natDataCost = effectiveNatDataGb * (NETWORKING_RATES.nat_data_processed_gb * rMult);
  const totalNatMonthly = natHourlyCost + natDataCost;

  const albCount = Math.max(0, Number(networking.albCount) || 0);
  const baseAlbLcus = Math.max(0, Number(networking.albLcus) || 0);
  const effectiveAlbLcus = baseAlbLcus * Math.max(1, burstMultiplier);
  const albHourlyCost = albCount * (NETWORKING_RATES.alb_hourly * 730 * rMult);
  const albLcuCost = effectiveAlbLcus * (NETWORKING_RATES.alb_lcu_hourly * 730 * rMult);
  const totalAlbMonthly = albHourlyCost + albLcuCost;

  const baseEgressGb = Math.max(0, Number(networking.internetEgressGb) || 0);
  const effectiveEgressGb = baseEgressGb * Math.max(1, burstMultiplier);
  const billableEgressGb = Math.max(0, effectiveEgressGb - NETWORKING_RATES.internet_egress_free_gb);
  const internetEgressMonthly = billableEgressGb * (NETWORKING_RATES.internet_egress_rate_gb * rMult);

  const baseCrossAzGb = Math.max(0, Number(networking.multiAzEgressGb) || 0);
  const effectiveCrossAzGb = baseCrossAzGb * Math.max(1, burstMultiplier);
  const crossAzMonthly = effectiveCrossAzGb * (NETWORKING_RATES.cross_az_egress_gb * 2 * rMult);

  const totalNetworkingMonthly = totalNatMonthly + totalAlbMonthly + internetEgressMonthly + crossAzMonthly;

  // Aggregate Totals
  const totalMonthlyCost = totalEc2Monthly + totalS3Monthly + totalRdsMonthly + totalNetworkingMonthly;
  const totalAnnualCost = totalMonthlyCost * 12;

  const uncommittedTotalMonthly = (ec2OnDemandMonthly + ebsMonthly) + totalS3Monthly + totalRdsMonthly + totalNetworkingMonthly;
  const annualFinopsSavings = (uncommittedTotalMonthly - totalMonthlyCost) * 12;

  // Bill of Materials (BOM)
  const bom = [
    {
      id: 'ec2_compute',
      category: 'Compute',
      item: `EC2 (${effectiveEc2Qty}x ${instanceObj.id})`,
      detail: `${instanceObj.vcpu} vCPU, ${instanceObj.ram} GB RAM | ${planObj.label}`,
      monthlyCost: ec2ComputeMonthly,
      percentOfTotal: totalMonthlyCost > 0 ? (ec2ComputeMonthly / totalMonthlyCost) * 100 : 0
    },
    {
      id: 'ebs_storage',
      category: 'Storage',
      item: `EBS Volumes (${ec2.ebsType ? ec2.ebsType.toUpperCase() : 'GP3'})`,
      detail: `${effectiveEc2Qty * ebsGb} GB Total Attached + ${ebsSnapshotsGb} GB Snapshots`,
      monthlyCost: ebsMonthly,
      percentOfTotal: totalMonthlyCost > 0 ? (ebsMonthly / totalMonthlyCost) * 100 : 0
    },
    {
      id: 's3_storage',
      category: 'Storage',
      item: 'Amazon S3 Object Storage',
      detail: `${(s3StdGb + s3IaGb + s3GlacierGb).toLocaleString()} GB Provisioned + Requests`,
      monthlyCost: totalS3Monthly,
      percentOfTotal: totalMonthlyCost > 0 ? (totalS3Monthly / totalMonthlyCost) * 100 : 0
    },
    {
      id: 'rds_database',
      category: 'Database',
      item: `RDS ${rdsEngineObj.name}`,
      detail: `${rdsClassObj.id} (${rdsClassObj.vcpu} vCPU, ${rdsClassObj.ram} GB) | ${isMultiAz ? 'Multi-AZ' : 'Single-AZ'}`,
      monthlyCost: totalRdsMonthly,
      percentOfTotal: totalMonthlyCost > 0 ? (totalRdsMonthly / totalMonthlyCost) * 100 : 0
    },
    {
      id: 'nat_gateways',
      category: 'Networking',
      item: `VPC NAT Gateway (${natCount}x)`,
      detail: `${effectiveNatDataGb.toLocaleString()} GB Processed Data Transfer`,
      monthlyCost: totalNatMonthly,
      percentOfTotal: totalMonthlyCost > 0 ? (totalNatMonthly / totalMonthlyCost) * 100 : 0
    },
    {
      id: 'alb_balancer',
      category: 'Networking',
      item: `Application Load Balancer (${albCount}x)`,
      detail: `${effectiveAlbLcus} LCUs provisioned capacity`,
      monthlyCost: totalAlbMonthly,
      percentOfTotal: totalMonthlyCost > 0 ? (totalAlbMonthly / totalMonthlyCost) * 100 : 0
    },
    {
      id: 'internet_egress',
      category: 'Networking',
      item: 'Internet & Cross-AZ Data Transfer',
      detail: `${effectiveEgressGb.toLocaleString()} GB Outbound + ${effectiveCrossAzGb.toLocaleString()} GB Inter-AZ`,
      monthlyCost: internetEgressMonthly + crossAzMonthly,
      percentOfTotal: totalMonthlyCost > 0 ? ((internetEgressMonthly + crossAzMonthly) / totalMonthlyCost) * 100 : 0
    }
  ];

  // FinOps Anomaly Risk Flags
  const finopsRisks = [];
  if (natCount > 0 && effectiveNatDataGb > 500) {
    finopsRisks.push({
      level: 'warning',
      title: 'High NAT Gateway Data Processing Overhead',
      desc: `Processing ${effectiveNatDataGb} GB through NAT Gateways costs $${natDataCost.toFixed(2)}/mo. Consider implementing AWS VPC Gateway Endpoints for Amazon S3 and DynamoDB to route traffic free over the AWS backbone.`
    });
  }

  if (isMultiAz && effectiveCrossAzGb > 400) {
    finopsRisks.push({
      level: 'caution',
      title: 'Multi-AZ Inter-Region / Inter-Zone Egress Surcharge',
      desc: `Cross-AZ traffic incurs $0.01/GB in each direction ($${crossAzMonthly.toFixed(2)}/mo). Keep chatty service-to-service communication within the same availability zone or use read-replicas wisely.`
    });
  }

  if (commitmentPlan === 'on_demand' && totalEc2Monthly > 120) {
    finopsRisks.push({
      level: 'opportunity',
      title: 'High On-Demand Compute Spend Detected',
      desc: `You are running ${effectiveEc2Qty} EC2 instances on On-Demand rates. Switching to a 1-Year or 3-Year Compute Savings Plan would save between $${(ec2OnDemandMonthly * 0.36).toFixed(2)} and $${(ec2OnDemandMonthly * 0.62).toFixed(2)} every month.`
    });
  }

  if (burstMultiplier > 1.0) {
    finopsRisks.push({
      level: 'burst',
      title: `Active Traffic Surge Simulation (${burstMultiplier}x Multiplier)`,
      desc: `During a ${burstMultiplier}x traffic spike, total monthly expenditure expands from $${(totalMonthlyCost / burstMultiplier).toFixed(2)} to $${totalMonthlyCost.toFixed(2)}/mo due to autoscaled compute and egress elasticity.`
    });
  }

  return {
    region: regionObj,
    effectiveEc2Qty,
    instanceObj,
    rdsClassObj,
    rdsEngineObj,
    isMultiAz,
    planObj,
    totalMonthlyCost,
    totalAnnualCost,
    uncommittedTotalMonthly,
    ec2SavingsMonthly,
    annualFinopsSavings,
    categoryCosts: {
      compute: totalEc2Monthly,
      storage: totalS3Monthly + ebsMonthly,
      database: totalRdsMonthly,
      networking: totalNetworkingMonthly
    },
    bom,
    finopsRisks
  };
};
